"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { ReactCompareSlider } from "react-compare-slider";
import { getBlurUrl } from "components/Image/utils";

type BeforeAfterCompareProps = {
  beforeImageUrl: string;
  afterImageUrl: string;
  beforeLabel?: string;
  afterLabel?: string;
};

const BeforeAfterCompare: React.FC<BeforeAfterCompareProps> = ({
  beforeImageUrl,
  afterImageUrl,
  beforeLabel = "Before",
  afterLabel = "After"
}) => {
  const labelStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px 5px 5px 5px",
    margin: "0 0px",
    color: "black",
    width: "80px",
    backgroundColor: "hsla(0,0%,100%,.8)",
    border: "0.5px solid black",
    fontSize: "0.75rem",
    fontWeight: 300, // Changed to a number
    cursor: "pointer",
    userSelect: "none" // Ensure this is a valid value
  };

  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Detect if the device is a touch device
    setIsTouchDevice(window.matchMedia("(pointer: coarse)").matches);
  }, []);

  return (
    <div className="relative z-[1] mx-auto">
      <ReactCompareSlider
        boundsPadding={80}
        itemOne={
          <div className="relative h-full w-full">
            <Image
              src={beforeImageUrl}
              alt="Before Image"
              width={1200}
              placeholder="blur"
              blurDataURL={getBlurUrl()}
              quality={75}
              height={751}
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }}
            />
          </div>
        } // Use next/image's Image component
        itemTwo={
          <div className="relative h-full w-full">
            <Image
              src={afterImageUrl}
              alt="After Image"
              width={1200}
              height={751}
              quality={75}
              placeholder="blur"
              blurDataURL={getBlurUrl()}
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }}
            />
          </div>
        }
        handle={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%"
            }}
          >
            {/* Before label and SVG */}
            <div style={{ ...labelStyle, borderRadius: "20px 0 0 20px" }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.8,16L6.4,9.6l6.4-6.4" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round"></path>
              </svg>
              {beforeLabel}
            </div>
            <div style={{ ...labelStyle, borderRadius: "0 20px 20px 0" }}>
              {afterLabel}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.4,3.2l6.4,6.4L6.4,16" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round"></path>
              </svg>
            </div>
          </div>
        }
        position={35}
        onlyHandleDraggable={isTouchDevice}
      />
    </div>
  );
};

export default BeforeAfterCompare;
